import { render, staticRenderFns } from "./FTPSyncButton.vue?vue&type=template&id=8f65ca1c"
import script from "./FTPSyncButton.vue?vue&type=script&lang=js"
export * from "./FTPSyncButton.vue?vue&type=script&lang=js"
import style0 from "./FTPSyncButton.vue?vue&type=style&index=0&id=8f65ca1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports